module.exports = __webpack_public_path__ + "static/media/Search.0eafb51e.png";